import {ChangeDetectionStrategy, Component} from '@angular/core';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {delay, map, withLatestFrom} from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'lina-lina-loading',
  templateUrl: './lina-loading.component.html',
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./lina-loading.component.scss']
})
export class LinaLoadingComponent {
  isLoading = false;
  progress$ = this.loader.progress$.pipe(
    delay(700),
    withLatestFrom(this.loader.progress$),
    map(v => {
      if (v[0] === 0 && v[1] === 0) {
        this.isLoading = false;
        // console.log('Loading completed: ', moment().toISOString());
      } else if (!this.isLoading) {
        this.isLoading = true;
        // console.log('Loading started: ', moment().toISOString());
      }

      return v[1];
    })
  );

  constructor(public loader: LoadingBarService) {
  }

}
